import api from './api';

export const sendLog = async (logData) => {
    try {
        await api.post('/logs', logData);
    } catch (error) {
        console.error('Error sending logs:', error);
        throw error;
    }
};
